import React, { useState } from 'react';
import { ActionIcon, Checkbox, Group, Text } from '@mantine/core';
import { IconFolder, IconFolderOpen } from '@tabler/icons-react'

type FileTreeProps = {
  data: any[]
  handleSelect: ({ checked, element }: { checked: boolean, element: any } ) => void
}

export const FileTree = ({ data, handleSelect }: FileTreeProps) => {
  const [isOpen, setIsOpen] = useState<any>({});

  const toggleNode = (text: any) => {
    setIsOpen((prevState: any) => ({
      ...prevState,
      [text]: !prevState[text]
    }));
  };

  if (!data) return <></>

  const renderTree = (nodes: any[]) => (
    <ul style={{ listStyleType: 'none', padding: 0 }}>
      {nodes.map((node) => (
        <li key={node.text} style={{ paddingLeft: 15 }}>
          {node.children ? (
            <>
              <Text onClick={() => toggleNode(node.text)} style={{ cursor: 'pointer' }}>
                {isOpen[node.text] ?
                <ActionIcon variant='transparent' mr={10}>
                  <IconFolderOpen style={{ width: '80%', height: '80%' }} stroke={2} />
                </ActionIcon> :
                <ActionIcon variant='transparent' mr={10}>
                  <IconFolder style={{ width: '80%', height: '80%' }} stroke={2} />
                </ActionIcon>
                }
                  <Text span>{node.text}</Text>
              </Text>
              {isOpen[node.text] && renderTree(node.children)}
            </>
          ) : (
            <Group wrap='nowrap'>
              <Checkbox
                onChange={(e) => handleSelect({ checked: e.target.checked, element: node })}
                defaultChecked={node.checked}
                // label={node.text}
              />
              <Text style={{ textWrap: 'nowrap' }}>{node.text}</Text>
            </Group>
          )}
        </li>
      ))}
    </ul>
  );

  return <div>{renderTree(data)}</div>;
};
